import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Modal from '@bd/bdui-modal';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import ContactModalForm from './ContactModalForm';
import { colors, typography } from './../styles';

const modalStyles = css`
  position: absolute;
  width: calc(100vw - 40px);
  max-width: 535px;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0,0,0,.8);
  @media (min-width: 768px) {
    top: 45px;
    width: 535px;
  }
  form {
    @media (max-width: 767px) {
      width: 100%;
    }
  }
  .ContactModal_header {
    background-color: ${colors.color1Lighter};
    z-index: 2;
    position: relative;
    padding: 19px 23.5px 15px;
    display: flex;
    align-items: center;
    @media (min-width: 768px) {
      padding: 35px 32px 32px;
    }
  }
  .ContactModal_modalClose {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 20px;
    height: 20px;
    &::before, &::after {
      content: '';
      display: block;
      width: 1px;
      height: 29.497475px;
      position: absolute;
      top: 50%;
      left: 50%;
      background-color: white;
      border-radius: 0.5px;
    }
    &::before {
      transform: translateX(-50%) translateY(-50%) rotateZ(45deg);
    }
    &::after {
      transform: translateX(-50%) translateY(-50%) rotateZ(-45deg);
    }
    @media (min-width: 768px) {
      top: 15px;
      right: 15px;
      width: 20px;
      height: 20px;
      &::before, &::after {
        width: 2px;
        border-radius: 1px;
      }
    }
  }
  .ContactModal_headerPhotoWrapper {
    display: none;
    @media (min-width: 768px) {
      display: block;
      width: 118px;
      height: 118px;
      border-radius: 50%;
      margin-right: 28px;
    }
  }
  .ContactModal_headerPhoto {
    display: block;
    width: 100%;
    height: 118px;
    border-radius: 50%;
    object-fit: cover;
  }
  .ContactModal_titleWrapper {
  }
  .ContactModal_title {
    font-size: 32px;
    font-weight: 300;
    color: ${colors.white};
    line-height: 1.125;
    margin: 0;
    font-family:${typography.Serif};
    font-style:italic;
    @media (min-width: 768px) {
      font-size: 43px;
      position: relative;
      padding-bottom: 13px;
      margin-bottom: 10px;
      &::after {
        content: '';
        display: block;
        width: 75px;
        height: 2px;
        background-color: ${colors.color1};
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
  .ContactModal_postTitle {
    display: block;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.130625em;
    line-height: 17px;
    text-transform: uppercase;
    font-family:${typography.SansSerif};
    @media (min-width: 768px) {
      font-size: 18px;
      line-height: 24px;
    }
  }
  .ContactModal_headerPhone {
    display: none;
    @media (min-width: 768px) {
      display: block;
      font-size: 21px;
      font-weight: bold;
      line-height: 24px;
      letter-spacing: 2.74px;
      color: ${colors.color5};
      margin-bottom: 0;
    }
  }
  .ContactModal_body {
    padding: 17px;
    display: block;
    justify-content: center;
    background-color: ${colors.white};
    @media (min-width: 768px) {
      padding: 23px;
    }
  }
  .invalid-feedback {
    color: #dc3545;
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background-color: rgba(0,0,0, 0.75);
  overflow-y: auto;
`;

const formStyles = css``;

class ContactModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      this.setState({
        modalIsOpen: true,
      });
    }
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { children, builder, communityAgentPhoto, agent, formName, formLabel } = this.props;
    const agentPhoto = communityAgentPhoto || get(agent, 'logo.contentUrl') || get(builder, 'osc_photo.contentUrl');
    return (
      <div className="ContactModal_wrapper mx-auto">
        <span className="ContactModal_triggerButton" role="button" tabIndex={0} onClick={this.openModal}>
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Contact Modal"
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <div className="ContactModal_header">
            <a href className="ContactModal_modalClose" onClick={this.closeModal}>
              <span className="sr-only">close window</span>
            </a>
            {agentPhoto &&
              <div className="ContactModal_headerPhotoWrapper">
                <img className="ContactModal_headerPhoto" src={agentPhoto} alt="Contact" />
              </div>
            }
            <div className="ContactModal_titleWrapper">
              <h2 className="ContactModal_title">
                Have Questions?
                <span className="ContactModal_postTitle GoldText">We Have Your Answers!</span>
              </h2>
            </div>
          </div>
          <div className="ContactModal_body">
            <ContactModalForm
              className={formStyles}
              noRedirect
              formName={formName}
              formLabel={formLabel}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

ContactModal.propTypes = {
  builder: PropTypes.object.isRequired,
  communityAgentPhoto: PropTypes.string,
  children: PropTypes.node.isRequired,
  agent: PropTypes.object.isRequired,
  formName: PropTypes.string,
  formLabel: PropTypes.string,

};

ContactModal.defaultProps = {
  communityAgentPhoto: '',
  formName: undefined,
  formLabel: undefined,

};

export default withData(
  {
    builder: true,
    agent: true,
  },
)(ContactModal);



// WEBPACK FOOTER //
// ./src/components/ContactModal.js